/**
 * WaypointMark — the official Waypoint brand mark (the neon "W").
 *
 * Renders the raster logo tile, which carries its own dark background + glow,
 * so it looks correct on any surface in both light and dark themes. Use this
 * everywhere the brand mark appears (nav, footer, auth, app sidebars) instead
 * of hand-inlining an SVG, so the brand stays consistent in one place.
 *
 * The PNG masters live in /public/brand and are generated by
 * scripts/brand/generate.mjs from the source logo.
 */
export function WaypointMark({
  size = 28,
  rounded = 'rounded-md',
  className = '',
}: {
  /** Rendered width/height in px. */
  size?: number;
  /** Tailwind corner-radius class for the tile. */
  rounded?: string;
  className?: string;
}) {
  return (
    <img
      src="/brand/mark.png"
      alt="Waypoint"
      width={size}
      height={size}
      draggable={false}
      style={{ width: size, height: size }}
      className={`shrink-0 object-cover ${rounded} ${className}`}
    />
  );
}
